import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

async function submitEmail(email: string): Promise<void> {
  const { error } = await supabase.from('mailing_list').insert({ email });
  if (!error) return;
  // PostgreSQL unique violation
  if (error.code === '23505') {
    throw new Error("You're already on the list — we'll be in touch!");
  }
  throw new Error('Something went wrong. Please try again.');
}

export function useMailingList() {
  return useMutation({ mutationFn: submitEmail });
}
